module.exports = __webpack_public_path__ + "img/winter_mushroom.9fe44f76.png";